import { render, staticRenderFns } from "./SolicitudForm.vue?vue&type=template&id=c2b771be"
import script from "./SolicitudForm.vue?vue&type=script&lang=js"
export * from "./SolicitudForm.vue?vue&type=script&lang=js"
import style0 from "./SolicitudForm.vue?vue&type=style&index=0&id=c2b771be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports